'use client'

import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface ScriptSwitchProps {
  script: 'simplified' | 'traditional'
  onToggle: () => void
  className?: string
}

export function ScriptSwitch({
  script,
  onToggle,
  className
}: ScriptSwitchProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Label
        htmlFor="script-switch"
        className="flex cursor-pointer items-center gap-2 text-xs font-medium select-none"
      >
        <span
          className={
            script === 'simplified'
              ? 'text-foreground'
              : 'text-muted-foreground'
          }
        >
          简体
        </span>
        <Switch
          id="script-switch"
          checked={script === 'traditional'}
          onCheckedChange={onToggle}
          aria-label="Toggle between simplified and traditional Chinese"
        />
        <span
          className={
            script === 'traditional'
              ? 'text-foreground'
              : 'text-muted-foreground'
          }
        >
          繁體
        </span>
      </Label>
    </div>
  )
}
